import {PageWithoutFooter} from "./Page";

export const SuspensePage = () => {
  return <PageWithoutFooter>
    <div className="h-screen w-full bg-gray-200"/>
  </PageWithoutFooter>
};